import { Box, Container, Typography } from '@material-ui/core';
import React, { memo } from 'react';
import ManageSocialAccounts from '../ManageSocialAccounts/ManageSocialAccounts';
import { useConnectedAccountStyles } from './styles';

const ConnectedAccountsPage: React.FC = () => {
  const classes = useConnectedAccountStyles();

  return (
    <Container disableGutters maxWidth="xl">
      <Box mb={4}>
        <Typography variant="h5" className={classes.connAcc}>
          Connected accounts
        </Typography>
      </Box>
      <Box mb={3}>
        <Typography variant="body1" className={classes.bodyFix}>
          Connect and disconnect accounts that you use to sign in My Cambridge.
        </Typography>
      </Box>
      <ManageSocialAccounts />
    </Container>
  );
};

export default memo(ConnectedAccountsPage);
